import React, { useState } from "react";
import { ManageEligibilityLayout } from "../../../components";
import { Image, InputGroup, Button, Row, Col, Form } from "react-bootstrap";
import { FormControlSearch } from "../../../components";

const EligibilityContainer = (props) => {
  return (
    <ManageEligibilityLayout>
      <div className="placeholder-text">PLACEHOLDER</div>
    </ManageEligibilityLayout>
  );
};

export default EligibilityContainer;
